(function($){

    // Initialize each block on page load (front end).
    $(document).ready(function(){
        var sliderHome = tns({
            container: '.product-slider-wrapper',
            items: 1,
            autoplay: true,
            autoplayButtonOutput: false,
            nav: false,
            autoplayTimeout: 6000,
            speed: 2000,
            controlsText: ['<i class="far fa-chevron-left"></i>', '<i class="far fa-chevron-right"></i>'],
            mouseDrag: true,
            gutter: 40,
            responsive: {
                640: {
                items: 2
                },
                769: {
                gutter: 30
                },
                1000: {
                items: 3
                }
            }
        });

         //$('button[data-controls=next]').addClass('animate__bounceInRight slow toAnimate');
         //$('button[data-controls=prev]').addClass('animate__bounceInLeft slow toAnimate');
    });



})(jQuery);